import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import {
  REACT_QUERY_CUSTOMER_BONUS_QUERY_HISTORY_KEY,
  REACT_QUERY_CUSTOMER_BONUS_CUSTOMERS_QUERY_KEY,
  REACT_QUERY_CUSTOMER_BONUS_QUERY_HISTORY_INFINITE_KEY,
} from '../constants';
import customerBonusUseCase from '../factories/customerBonus';

export const useGetCustomers = (variables, options = {}) => {
  const query = useQuery(
    [REACT_QUERY_CUSTOMER_BONUS_CUSTOMERS_QUERY_KEY, variables],
    () => customerBonusUseCase.getCustomers(variables),
    options
  );

  return query;
};

export const useGetHistory = (variables, options = {}) => {
  const query = useQuery(
    [REACT_QUERY_CUSTOMER_BONUS_QUERY_HISTORY_KEY, variables],
    () => customerBonusUseCase.getHistory(variables),
    options
  );

  return query;
};

export const useGetHistoryInfinite = (variables, options = {}) => {
  const query = useInfiniteQuery(
    [REACT_QUERY_CUSTOMER_BONUS_QUERY_HISTORY_INFINITE_KEY, variables],
    ({ pageParam = 0 }) => {
      if (pageParam === null) {
        return { history: [], meta: {} };
      }

      return customerBonusUseCase.getHistory({
        ...variables,
        offset: pageParam,
      });
    },
    {
      getNextPageParam: (lastPage) => {
        const { offset = 0, limit = 10, total = 0 } = lastPage.meta || {};

        const nextOffset = offset + limit;

        if (nextOffset < total) {
          return nextOffset;
        }

        return null;
      },
      ...options,
    }
  );

  return query;
};

export const useTopUpBalance = () => {
  const mutation = useMutation(customerBonusUseCase.topUpBalance);
  return mutation;
};

export const useChargeFromBalance = () => {
  const mutation = useMutation(customerBonusUseCase.chargeFromBalance);
  return mutation;
};
